import axios from "axios";

// Set the default base URL
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

// Create another instance with a different base URL
const anotherInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_TWO,
});

// You can set other properties here like headers, interceptors, etc.
// For example, to set a common header for all instances:
//const commonHeaders = {
//  'Content-Type': 'application/json',
//};

//axios.defaults.headers.common = commonHeaders;
//anotherInstance.defaults.headers.common = commonHeaders;

// Export the default axios instance and the other instance
export { axios as default, anotherInstance };
